import { read, utils } from 'xlsx';

export default {
  parse(file) {
    return new Promise((resolve, reject) => {
      if (!file) {
        reject(new Error('No file provided'));
        return;
      }
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = read(data, { type: 'array' });
          if (!workbook.SheetNames.length) {
            reject(new Error('No sheets found in workbook'));
            return;
          }
          const sheet = workbook.Sheets[workbook.SheetNames[0]];
          const jsonData = utils.sheet_to_json(sheet);
          if (!jsonData.length) {
            reject(new Error('No data found in sheet'));
            return;
          }
          const table = jsonData.map(obj => Object.entries(obj).map(item => item[1]));
          const headers = Object.keys(jsonData[0]).map(key => key);
          resolve({
            headers,
            table
          });
        } catch (error) {
          reject(new Error(`Failed to parse Excel file: ${error.message}`));
        }
      };
      reader.onerror = () => {
        reject(new Error('Failed to read file'));
      };
      reader.readAsArrayBuffer(file);
    });
  }
}